var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup',{attrs:{"title":("מצטערים, המערכת לא תומכת כרגע ב" + (_vm.source.displayName) + "..."),"close-action":_vm.popupClosed,"buttons":[
  {
    title: 'זה החשבון העיקרי שלי',
    subtitle: 'תעדכנו אותי כשתתמכו',
    action: _vm.primaryBankSelected,
    variant: 'primary',
  },
  {
    title: 'זה לא החשבון העיקרי',
    subtitle: 'אני רוצה להמשיך בלעדיו',
    action: _vm.continueWithoutSelected,
    variant: 'primary',
  } ]}})}
var staticRenderFns = []

export { render, staticRenderFns }